import React from "react";

import { ButtonStyles } from "./styles.module";

type Size = "small" | "medium" | "big"; // default

interface IButtonProps {
  classWrapper?: string;
  className?: string;
  disabled?: boolean;

  size?: Size;
  outlined?: boolean;
  filled?: boolean;
  onSubmit?(e: any): void;
  children?: React.ReactNode;
}

interface IButtonState {}

export class Button extends React.Component<IButtonProps, IButtonState> {
  state: IButtonState = {};

  render() {
    const size = this.props.size ? `--${this.props.size}` : "--big";
    const className = this.props.className ? this.props.className : "";
    const outlined = this.props.outlined ? "--outlined" : "";
    const filled = this.props.filled ? "--filled" : "";

    return (
      <ButtonStyles
        className={`${this.props.classWrapper ? this.props.classWrapper : ""}`}
      >
        <button
          className={`button ${className} ${size} ${outlined} ${filled}`}
          disabled={!!this.props.disabled}
          onClick={(e) => this.props.onSubmit && this.props.onSubmit(e)}
        >
          {this.props.children}
        </button>
      </ButtonStyles>
    );
  }
}
